// types
import { DataRequestField } from '../../../@types';

// mui
import {
	Box,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Radio,
	RadioGroup,
	Typography,
} from '@mui/material';

// props
export interface YesNoProps {
	field: DataRequestField;
	value: unknown;
	onChange: (value: unknown) => void;
	disabled: boolean;
	readOnly: boolean;
	error?: string | null;
}

export const YesNo = ({ field, value, onChange, disabled, readOnly, error }: YesNoProps) => {
	const current =
		value == null
			? ''
			: typeof value === 'boolean'
				? value
					? 'yes'
					: 'no'
				: String(value).toLowerCase();
	return (
		<Box>
			<Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
				{field.label}
				{field.required === true ? ' *' : ''}
			</Typography>
			<FormControl
				error={!!error}
				disabled={disabled || readOnly}
				required={field.required === true}
				component="fieldset">
				<RadioGroup row value={current} onChange={(_, v) => onChange(v)} name={`yesno-${field.id}`}>
					<FormControlLabel value="yes" control={<Radio size="small" />} label="Yes" />
					<FormControlLabel value="no" control={<Radio size="small" />} label="No" />
				</RadioGroup>
				{error && <FormHelperText>{error}</FormHelperText>}
			</FormControl>
		</Box>
	);
};
